<template>
  <variants>
    <template #narrow>
      <div
        class="flex flex-wrap justify-center gap-3 items-center p-fl-lg border border-[#535353] rounded-md"
      >
        <div class="text-fl-xl text-full-white">Grab the FREE download for this video</div>
        <standard-button
          :url="downloadUrl"
          :label="'Get the FREE download →'"
          :color="'cta'"
          :expand="true"
          :new-tab="true"
        />
      </div>
    </template>
    <template #sm+>
      <div
        class="flex flex-wrap justify-between gap-3 items-center p-fl-xl border border-[#535353] rounded-xl"
      >
        <div class="text-fl-xl text-full-white">Grab the FREE download for this video</div>
        <standard-button
          :url="downloadUrl"
          :label="'Get the FREE download →'"
          :color="'cta'"
          :new-tab="true"
        />
      </div>
    </template>
  </variants>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import StandardButton from '../../../core/button/StandardButton.vue';
import Variants from '../../../core/column-layout/Variants.vue';

export default defineComponent({
  components: {StandardButton, Variants},
  props: {
    downloadUrl: {type: String as PropType<string>, default: ''}
  }
});
</script>
